import { SupportedLocale } from "@intocare/datatypes/lib/i18n";

import { RestrictiveMeasuresReportData } from "./types";
import { createConfiguredPdf } from "../../shared/pdf-maker";
import { createDocumentContextFor } from "../templates/document-context";
import { getRestrictiveMeasuresDefinition } from "../templates/restrictive-measures-report";

export const generateRestrictiveMeasuresReport = (data: RestrictiveMeasuresReportData, locale: SupportedLocale) =>
	createConfiguredPdf(getRestrictiveMeasuresDefinition(createDocumentContextFor({ locale }), data));

export const getRestrictiveMeasuresFileName = (
	residentFullName: string,
	documentType: RestrictiveMeasuresReportData["documentType"],
	locale: SupportedLocale,
): string => {
	const ctx = createDocumentContextFor({ locale });
	const prefix =
		documentType === "ACTIVE"
			? ctx.t("features/pdf-generation.restrictiveMeasures.applicationApproval.fileNamePrefix")
			: ctx.t("features/pdf-generation.restrictiveMeasures.discontinuationApproval.fileNamePrefix");
	const now = new Date();
	const isoString = now.toISOString().replace(/\.\d{3}Z$/, "Z");
	const sanitizedName = residentFullName.replace(/\s+/g, "_");
	return `${sanitizedName}_${prefix}_${isoString}.pdf`;
};
